import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Policies } from '@app/auth/auth-policies';
import { AuthService } from '@app/auth/auth.service';
import { PaymentStatus } from '@models/appointments/payment-status';
import { Service } from '@models/service/service';
import { ServiceDetailTemplate } from '@models/service/service-detail-template';
import { ServiceListType } from '@models/service/service-list-type';
import { TabType } from '@models/tab-type.enum';
import { PlannedTreatment } from '@models/treatment-planning/planned-treatment';
import { CurrentDataService } from '@services/currentData.service';
import { PatientService } from '@services/patient.service';
import { TreatmentPlanService } from '@services/treatment-planning/treatment-plan.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-advanced-treatment',
  templateUrl: './advanced-treatment.component.html',
  styleUrls: ['./advanced-treatment.component.less'],
})
export class AdvancedTreatmentComponent implements OnInit, OnDestroy {
  @Input() set service(service) {
    this._service = service;
  }
  private _service: Service;
  get service() {
    return this.associatedPlannedTreatment ? this.associatedPlannedTreatment.service : this._service;
  }
  @ViewChild('detailSection', { static: true }) detailSection: ElementRef;

  loading = true;
  ready = false;
  treatmentPlanning = false;
  customListClasses: string[];
  patientId: number;
  associatedPlannedTreatment: PlannedTreatment;
  patientChartEditPolicy = Policies.patientChartEdit;
  patientChartEditPolicySatisfied = false;
  unsub: Subject<void> = new Subject<void>();

  serviceListType = ServiceListType;
  serviceDetailTemplate = ServiceDetailTemplate;
  PaymentStatus = PaymentStatus;
  TabType = TabType;

  @HostListener('window:resize', ['$event'])
  onScreenResize() {
    if (this.detailSection) {
      this.currentDataService.serviceDetailSectionHeightUpdated(this.detailSection.nativeElement.offsetHeight);
    }
  }

  constructor(
    public patientService: PatientService,
    private route: ActivatedRoute,
    private currentDataService: CurrentDataService,
    private treatmentPlanService: TreatmentPlanService,
    private authService: AuthService
  ) {
    this.customListClasses = ['w-100'];
  }
  ngOnDestroy() {
    this.currentDataService.serviceDetailSectionHeightUpdated(0);

    this.unsub.next();
    this.unsub.complete();
  }

  ngOnInit() {
    this.currentDataService.preventUserFromNavigation$.pipe(takeUntil(this.unsub)).subscribe((loading) => {
      this.loading = loading;
    });

    this.route.params.subscribe((params) => {
      this.treatmentPlanning = JSON.parse(params.treatmentPlanning);

      if (this.service) {
        //only do the observation copy-back if adding from the appointment
        this.treatmentPlanService.getAssociatedTreatmentByServiceId(this.service.serviceId).subscribe((pt) => {
          if (pt) {
            this.associatedPlannedTreatment = pt;
            this.associatedPlannedTreatment.service.isLocked = this._service.isLocked;
          }
          this.ready = true;
        });
      } else {
        this.ready = true;
      }
      this.loading = false;
      setTimeout(() => {
        if (this.detailSection) {
          this.currentDataService.serviceDetailSectionHeightUpdated(this.detailSection.nativeElement.offsetHeight);
        }
      });
    });

    this.patientId = this.route.snapshot.params.patId.split('_')[0];
    this.currentDataService.treatmentIsDirty = false;
    this.patientChartEditPolicySatisfied = this.authService.userSatisfiesPolicy(this.patientChartEditPolicy);
  }
}
